import React from 'react';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
    return (
        <div className="flex items-center justify-center min-h-screen font-gotham-rounded ">
            <div className="bg-white p-8 rounded-lg  text-center">
                <h1 className="text-6xl font-bold text-red-600 mb-4">404</h1>
                <h2 className="text-2xl font-semibold mb-4">Page Not Found</h2>
                <p className="text-gray-600 mb-8">
                    Sorry, the page you are looking for does not exist. You can always go back to the <Link to="/" className="text-blue-500 hover:underline">Login</Link>.
                </p>
                <Link to="/login" className="inline-block px-6 py-2 text-sm font-medium leading-6 text-center text-white bg-blue-500 hover:bg-blue-600 rounded-full shadow-sm">
                    Return to login
                </Link>
            </div>
        </div>
    );
}

export default ErrorPage;